import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'next-i18next';

const RadioGroup = ({ children, errors, name, ariaLabel }) => {
    const { t } = useTranslation('');
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    return (React.createElement("div", { className: "radio-group", role: "radiogroup", "aria-label": ariaLabel },
        React.createElement("div", { className: "radio-group-items" }, children),
        isError && (React.createElement("div", { className: "error", role: "alert" }, t(errorText)))));
};

export { RadioGroup as R };
//# sourceMappingURL=RadioGroup-ZDexyLRv.js.map
